import Vue from "vue";
import VueRouter, { RouteConfig, Route } from "vue-router";
import store from "@/store/index";
import { AppMutation } from "@/store/app/types";

Vue.use(VueRouter);

const routes: RouteConfig[] = [
  {
    path: "/",
    name: "customerSatisfactionSurvey",
    component: () =>
      import(
        /* webpackChunkName: "customerSatisfactionSurvey" */ "../views/CustomerSatisfactionSurvey.vue"
      ),
    meta: {
      breadCrumb: "",
    },
  },
  {
    path: "/login",
    name: "login",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/LoginPage.vue"),
    meta: {
      noAuth: true,
    },
  },
  {
    path: "/customer/feedback",
    name: "customerFeedback",
    component: () =>
      import(
        /* webpackChunkName: "customerFeedback" */ "../views/ThankLetter.vue"
      ),
    meta: {
      breadCrumb: "Customer Feedback",
    },
  },
  {
    path: "*",
    name: "404",
    component: () =>
      import(/* webpackChunkName: "notfound" */ "../views/NotFound.vue"),
    meta: {
      breadCrumb: " ",
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: (
    to: Route,
    from: Route,
    savedPosition: { x: number; y: number } | void,
  ) => {
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  const check: boolean = store.getters.isAuthenticated || to.meta?.noAuth;
  const lang: string = store.getters.getLanguage;
  const param = to.query.lang;
  if (param) {
    store.commit(AppMutation.SET_LANGUAGE, param);
  }
  if (check) {
    // next
    return next();
  } else {
    // return to login if user not logged
    return next({
      path: "/login",
      query: {
        lang: param || (lang || "en"),
      },
    });
  }
});

export default router;
